// extracted by mini-css-extract-plugin
module.exports = {"field":"UserAddPopup_field__3u12C","text":"UserAddPopup_text__35m9k"};